import React from 'react';
import {Row, Col} from 'antd';
import AppHeaderMenu from './AppHeaderMenu';

class AppHeader extends React.Component {
  render() {
    return (
      <Row className="app-header-row">
        <Col xs={16} sm={16} md={12}>
          <h2>Touko Hoshino</h2>
        </Col>
        <Col xs={8} sm={8} md={12}>
          <AppHeaderMenu />
        </Col>
      </Row>
    )
  }
}

export default AppHeader;